import { Modal } from '@mui/material';
import styled from 'styled-components';

export const Container = styled(Modal)``;
